module.exports = __webpack_public_path__ + "img/af.b5db981.svg";